import type { FeedbackMessages } from './en';

const sv: FeedbackMessages = {
  qualified: {
    title: 'Tack för att du genomförde denna undersökning!',
    body1: 'Du kan nu stänga webbläsarfönstret.',
    body2: 'Vi hoppas att få se dig igen snart.',
    refCode: 'Referenskod: {code}',
  },
  quotaFull: {
    title: 'Denna undersökning är stängd',
    body1: 'Tack för ditt intresse för vår undersökning.',
    body2: 'Tyvärr har vi redan fått in alla svar vi behöver.',
    body3: 'Vi hoppas att få se dig i en av våra framtida undersökningar!',
    refCode: 'Referenskod: {code}',
  },
  terminated: {
    title: 'Tack för att du delade din feedback!',
    body1:
      'Vi hoppas att få se dig snart i våra framtida undersökningar. Fram tills då önskar vi dig en fin dag.',
    body2: 'Var vänlig stäng detta webbläsarfönster.',
    refCode: 'Referenskod: {code}',
  },
  mismatch: {
    title: 'Tack för ditt intresse',
    body1: 'Tyvärr ingår du inte i målgruppen för denna specifika undersökning.',
    body2: 'Du kan stänga denna sida.',
    code: 'Kod: {code}',
  },
  error: {
    title: 'Vi kan inte behandla din begäran',
    linkProblemDetailed:
      'Länken du har följt har problem. Kontrollera att länken i adressfältet stämmer med den du fått, och försök igen.',
    linkProblemGeneric: 'Länken du har följt har problem. Försök igen.',
    contactPerson:
      'Om problemet kvarstår, vänligen informera personen du fick länken från om detta problem.',
    errorCode: 'Felkod: {code}',
  },
};

export default sv;
